import { gql } from '@apollo/client'

export default gql`
  fragment FullObjectivePayment on ObjectivePayment {
    id
    meetingId
    deduction
    deductionReason
    paymentDate
    status
    paymentDateValid
  }
`
